export const colorGreen = "#73C580"
export const colorRed = "#D91A1A"
export const colorOrange = "#F77B21"
export const colorYellow = "#DDBB08"
export const colorGrey = "rgb(170, 167, 153)"

export const translateDecisionStatus = (status) => {
    switch (status) {
        case "pending":
        case "in_queue":
            return "Em Processamento"
        case "waiting_for_data":
            return "Aguardando Dados"
        case "in_manual_analysis":
            return "Em Análise Manual"
        case "manually_approved":
            return "Aprovado Manualmente"
        case "automatically_approved":
            return "Aprovado Automaticamente"
        case "manually_reproved":
            return "Reprovado Manualmente"
        case "automatically_reproved":
            return "Reprovado Automaticamente"
        case "approved_by_time":
            return "Aprovado por tempo"
        case "reproved_by_time":
            return "Reprovado por tempo"
        case "manually_challenged":
            return "Contestado Manualmente"
        case "automatically_challenged":
            return "Contestado Automaticamente"
        case "on_hold":
            return "Em Espera"
        default:
            return status
    }
}

export const decisionStatusColor = (status) => {
    switch (status) {
        case "manually_approved":
        case "automatically_approved":
        case "approved_by_time":
            return colorGreen
        case "manually_reproved":
        case "automatically_reproved":
        case "reproved_by_time":
            return colorRed
        case "manually_challenged":
        case "automatically_challenged":
            return colorYellow
        case "pending":
        case "in_manual_analysis":
        case "waiting_for_data":
            return colorOrange
        default:
            return colorGrey
    }
}
